export enum SubscriptionTypeEnum {
  Basic = 1,
  Standard = 2,
  Premium = 3,
  Enterprise = 4
}
